/*
 * NOURION Kontaktseite, Verhalten.
 *
 *  1) Vorbefuellung des Nachrichtenfelds aus dem URL Parameter ?anfrage=...
 *     (z. B. die Arztpraxis Bundles auf der Leistungsseite). Der Text wird
 *     nur angehaengt, wenn er nicht schon im Feld steht; die Wache
 *     data-nkt-filled verhindert doppeltes Anhaengen bei erneutem Rendern.
 *     Die fruehere Uebernahme aus Anfrageliste und Bedarfscheck
 *     (sessionStorage nourion-anfrage) ist seit 23.10.2026 entfallen.
 *
 *  2) Barrierefreiheit beim Erfolgszustand (Bauregel 10): Shopify laedt
 *     die Seite nach dem Absenden komplett neu. Damit der Tastaturfokus
 *     nicht ins Leere faellt, wandert er auf die Erfolgs Ueberschrift
 *     (tabindex="-1").
 *
 * Re-Init bei shopify:section:load (Bauregel 6), idempotent.
 */
(function () {
  'use strict';

  function liesAnfrage() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('anfrage') || '';
    } catch (e) {
      /* URLSearchParams nicht verfuegbar: ohne Vorbefuellung weitermachen */
      return '';
    }
  }

  function befuelleNachrichtenfeld(feld) {
    if (!feld || feld.getAttribute('data-nkt-filled') === '1') return;
    feld.setAttribute('data-nkt-filled', '1');

    var text = liesAnfrage();
    if (!text) return;

    var aktuell = feld.value || '';
    if (aktuell.indexOf(text) !== -1) return;
    feld.value = aktuell ? (aktuell + '\n\n' + text) : text;
  }

  function fokussiereErfolg(scope) {
    var ueberschrift = (scope || document).querySelector('[data-nkt-success-heading]');
    if (!ueberschrift || ueberschrift.getAttribute('data-nkt-focused') === '1') return;
    ueberschrift.setAttribute('data-nkt-focused', '1');
    ueberschrift.focus();
  }

  function initScope(scope) {
    var wurzel = scope || document;
    var feld = wurzel.querySelector ? wurzel.querySelector('[data-nkt-message]') : null;
    if (feld) befuelleNachrichtenfeld(feld);
    fokussiereErfolg(wurzel);
  }

  initScope(document);

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) initScope(evt.target);
  });
})();
